export { BurgerOpener } from './burger-opener';
export type { BurgerOpenerProps } from './models';
